import OrderPropItem from "./OrderPropItem";
import {SVG__Ruble} from "../../SVG/SVG";
import {default as SubmitButton} from "./SubmitButtonWithGoogleRecaptcha"
import {useCallback, useState} from "react";
import {
	GoogleReCaptchaProvider,
	useGoogleReCaptcha
} from 'react-google-recaptcha-v3';


const OrderProps = (props) => {
	
	const {vars, totalPrice, deliveryPrice} = props;
	const totalPriceHTML = (totalPrice > 0) ?
		<span> {(totalPrice.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '))}
			<SVG__Ruble/></span> : props.zeroPrice;
	const deliveryPriceHTML = <span>{deliveryPrice} <SVG__Ruble/></span>;
	
	const {executeRecaptcha} = useGoogleReCaptcha();
	
	const onSubmit = useCallback(async (event) => {
		event.preventDefault();
		console.log('CLK!');
		
		if (!executeRecaptcha) {
			console.log('Execute recaptcha not yet available');
			return;
		}
		console.log('Fore recap!');
		const token = await executeRecaptcha('homepage');
		console.log('After recap: ', token);
		
		props._onOrder(event, token);
	}, [executeRecaptcha])
	
	
	return (
		<div className="order-props">
			<form action={vars.post_form_acton_uri}
			      method="POST"
			      name="ORDER_FORM"
			      id="bx-soa-order-form"
			      encType="multipart/form-data" onSubmit={onSubmit}>
				<div dangerouslySetInnerHTML={{__html: vars.bitrix_sessid_post}}/>
				<input type="hidden" id="ID_PAY_SYSTEM_ID_1" name="PAY_SYSTEM_ID" value="1"/>
				<input type="hidden" name="PERSON_TYPE" value="1"/>
				<input type="hidden" name="PERSON_TYPE_OLD" value="1"/>
				<input type="hidden" name="confirmorder" id="confirmorder" value="Y"/>
				<input type="hidden" name="DELIVERY_ID" value="10"/>
				<input type="hidden" name="save" value="Y"/>
				<input type="hidden" name="json" value="Y"/>
				<input type="hidden" name="showProps" value="N"/>
				<input type="hidden" name="BUYER_STORE"/>
				<input type="hidden" name="is_ajax_post" value="Y"/>
				<input type="hidden" name="profile_change" value="N"/>
				
				<div className="order-props__header">
					
					<h2>ОФОРМЛЕНИЕ ЗАКАЗА</h2>
				</div>
				<div className="order-props__body">
					{vars.items.map(item => item.all.ACTIVE === 'Y' && <OrderPropItem key={item.id} item={item}/>)}
				</div>
				<div className="order-props__footer">
					<div className="order-props__total-block">
						<div className="order-props__delivery">Доставка в пределах МКАД: <b>{deliveryPriceHTML}</b>
						</div>
						<div className="order-props__total-text">Итого:</div>
						<div className="order-props__total-value">
							<span className="order-props__total-sum">{totalPriceHTML}</span>
						</div>
						<div className="order-props__total-text">включая НДС</div>
					</div>
					
					<button name="submitbutton" className="btn btn-primary-inverted btn-block"
					        id="submitOrderButton" data-ya_goal={"cart_send_order"}><span>Оформить заказ</span>
					</button>
					
					<div className="confirmation">
						Нажимая кнопку "Оформить заказ", вы соглашаетесь с <a
						href="/policy/" target="_blank" rel="nofollow noopener">обработкой персональных
						данных</a> и принимаете условия&nbsp;<a href="/terms-to-use/" target="_blank" rel="nofollow noopener">"Пользовательского соглашения"</a>.
					</div>
				</div>
			</form>
		</div>
	)
}

export default OrderProps;